export var EqualisationSection;
(function (EqualisationSection) {
    EqualisationSection["Commitments"] = "Commitments";
    EqualisationSection["Investments"] = "Investments";
    EqualisationSection["Expenses"] = "Expenses";
    EqualisationSection["Income"] = "Income";
    EqualisationSection["ManagementFees"] = "ManagementFees";
    EqualisationSection["GeneralCapitalCalls"] = "GeneralCapitalCalls";
    EqualisationSection["ActionLinkedCapitalActions"] = "ActionLinkedCapitalActions";
    EqualisationSection["CapitalContributions"] = "CapitalContributions";
    EqualisationSection["EqualisationInterest"] = "EqualisationInterest";
    EqualisationSection["Summary"] = "Summary";
})(EqualisationSection || (EqualisationSection = {}));
export var FeesEqualisationTreatment;
(function (FeesEqualisationTreatment) {
    FeesEqualisationTreatment["Full"] = "full";
    FeesEqualisationTreatment["Partial"] = "partial";
    FeesEqualisationTreatment["None"] = "none";
})(FeesEqualisationTreatment || (FeesEqualisationTreatment = {}));
//# sourceMappingURL=index.js.map